import { SET_FLASH_MESSAGE } from "../actions/setFlashMessage";

export default (state = {}, action) => {
  switch (action.type) {
    case SET_FLASH_MESSAGE:
      return { ...state, flash: [action.message] };
    default:
      return state;
  }
};
